export const boolComparator = (a: boolean, b: boolean) => (!a && b ? -1 : a && !b ? 1 : 0);

export const numberComparator = (a: number, b: number) => (a < b ? -1 : a > b ? 1 : 0);

export const stringComparator = (a: string, b: string) =>
  a?.localeCompare(b, undefined, { sensitivity: 'base' });
